<template>
  <v-container class="pt-0">
    <v-row justify="center">
      <v-dialog
        v-model="open"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Periodo nuevo</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark text @click="saveDialog">
              <v-icon class="mr-2">mdi-content-save-edit</v-icon> Guardar
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="7">
                  <v-text-field
                    label="Ciclo"
                    required
                    v-model="datos.ciclo"
                    disabled
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="datos.semestre"
                    :items="[
                      { text: 'IMPAR (AGO-DIC)', value: '1' },
                      { text: 'PAR (FEB-JUL)', value: '2' },
                    ]"
                    label="Semestre"
                    disabled
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="datos.actual"
                    :items="[
                      { text: 'NO', value: '0' },
                      { text: 'SI', value: '1' },
                    ]"
                    label="Semestre Actual"
                    disabled
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="datos.proximo"
                    :items="[
                      { text: 'NO', value: '0' },
                      { text: 'SI', value: '1' },
                    ]"
                    label="Próximo Semestre"
                    disabled
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Periodo",

  props: {
    open: Boolean,
    datos: Object,
  },

  data: () => ({}),

  methods: {
    closeDialog() {
      this.$emit("exit");
    },

    saveDialog() {
      this.$emit("save");
    },
  },

  mounted() {},
};
</script>
